import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./lms/componets/HomePage";
import CoursesList from "./lms/componets/CoursesList";
import CourseDetails from "./lms/componets/CourseDetails";
import Gaudaan from "./lms/componets/Gaudaan";
import KarmKaand from "./lms/componets/KarmKaand";
import KarmKaandDetail from "./lms/componets/KarmKaandDetail";
import Services from "./lms/componets/Services";
import ServiceListing from "./lms/componets/ServiceListing";
import Courses from "./lms/componets/Courses";
import ContactUs from "./lms/componets/ContactUs";
import AboutUs from "./lms/componets/AboutUs";
import ScrollToTop from "./lms/componets/ScrollToTop";
import PrivacyPolicy from "./lms/componets/PrivacyPolicy";
import { CookiesProvider } from "react-cookie";
import Shop from "./lms/componets/Shops/Shop";


const App = () => {
  return (
    <CookiesProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/learn" element={<Courses />} />
          <Route path="/learn/courses" element={<CoursesList />} />
          <Route path="/learn/course/:courseName" element={<CourseDetails />} />
          <Route path="/gaudaan" element={<Gaudaan />} />
          <Route path="/karmkaand" element={<KarmKaand />} />
          <Route path="/karmkaand/:slug-url" element={<KarmKaandDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/priests" element={<ServiceListing />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/shop" element={<Shop />} />
        </Routes>
      </BrowserRouter>
    </CookiesProvider>

  );
};

export default App;

